<template>
	<div>
		<nav class="pagination">
			<ul class="pagination">
				<li class="page-item" v-if="page > 1">
				 <router-link class="page-link previous" :to="{ path: $route.path, query: { ...$route.query, page: previousPage} }">
						<span aria-hidden="true">
							<i class="fas fa-chevron-left"></i>
						</span>
						<span class="sr-only">Previous</span>
					</router-link>
				</li>
				<li class="page-item"
					v-for="(n, index) in lastPage"
					:class="{ active: isActivePage(n) }"
					v-if="showPaginate(n)"
					:key="index">
						<router-link
							class="page-link link"
							:to="{ path: $route.path, query: {  ...$route.query, page: n} }"
							:key="n"
						>
							{{ n }}
						</router-link>
				</li>
				<li class="page-item next" v-if="page < lastPage || !page">
					<router-link class="page-link link" :to="{ path: $route.path, query: { ...$route.query, page: nextPage } }">
						<span aria-hidden="true"><i class="fas fa-chevron-right"></i></span>
						<span class="sr-only">Next</span>
					</router-link>
				</li>
			</ul>
		</nav>
	</div>
</template>

<script>
export default {
	props: ['lastPage'],
	computed: {
		namespace() {
			return this.$route.params.namespace;
		},
		projectId() {
			return this.$route.params.projectId;
		},
		page() {
			return this.$route.query.page || 1;
		},
		limitPage() {
			if (this.page) {
				return parseInt(this.page, 10) + 4;
			}
			return 4;
		},
		nextPage() {
			return parseInt(this.page, 10) + 1;
		},
		previousPage() {
			return parseInt(this.page, 10) - 1;
		},
	},
	methods: {
		showPaginate(n) {
			if ((n < this.limitPage && n >= this.page) || this.lastPage < 5) {
				return true;
			} else if ((this.lastPage - n) < 4 && (this.lastPage - this.page) < 4) {
				return true;
			}
			return false;
		},
		isActivePage(n) {
			if (!this.page) {
				return n === 1;
			}
			return this.page.toString() === n.toString();
		},
	},
};
</script>


<style lang="scss" scoped>
@import '@/assets/scss/themes/variables.scss';

.pagination {
	padding-top: $spacer * 0.5;
	display: flex;
	justify-content: center;
}

.page-item {
	margin-left: 6px;
}

.page-link {
	background-color: #f5f5f5;
	border: none;
	width: 36px;
	height: 36px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: $secondary;
}

.page-item.active .page-link {
	background: $secondary;
}

.previous {
	margin-right: $spacer;
}

.next {
	margin-left: $spacer;
}

.fas {
	vertical-align: top;
	font-size: 15px;
	line-height: 1.7;
}

// Extra small devices (portrait phones, less than 576px)
@media (max-width: 575.98px) {
	.pagination {
		justify-content: center;
	}

}

// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) and (max-width: 767.98px) {
	.pagination {
		justify-content: center;
	}
}

// Medium devices (tablets, 768px and up)
@media (min-width: 768px) and (max-width: 991.98px) {
	.pagination {
		justify-content: center;
	}
}

// Large devices (desktops, 992px and up)
@media (min-width: 992px) and (max-width: 1199.98px) {
	.pagination {
		margin-bottom: $spacer * 2;
	}
}

// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
	.pagination {
		margin-bottom: $spacer * 3;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/elements/Pagination.vue